import {createApp} from 'vue'
import DocumentAndFolderList from './DocumentAndFolderList'

const el = '.kb-component--document-and-folder-list'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((DocumentAndFolderListDOM)=>{
            const props = {
                guid: DocumentAndFolderListDOM.dataset.guid ?? '',
                gruppeKode: DocumentAndFolderListDOM.dataset.gruppeKode ?? '',
                cardButtonIcons: DocumentAndFolderListDOM.dataset.cardButtonIcons
                    ? JSON.parse(DocumentAndFolderListDOM.dataset.cardButtonIcons)
                    : {},
                fileTypeDropdownOptions: JSON.parse(DocumentAndFolderListDOM.dataset.fileTypeDropdownOptions)
            }

            const component = createApp(DocumentAndFolderList, props).use(Store)
            component.mount(DocumentAndFolderListDOM)
        })
    }
}